import React from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Invoices from "./components/Invoices";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function CustomerBillingPage() {

  return (
    <DashboardLayout stickyNavbar>
      <DashboardNavbar />
      <MDBox mt={{ xs: 4, md: 10 }} mb={{ xs: 4, md: 8 }}>
        <Invoices />
      </MDBox>
    </DashboardLayout>
  );
}

export default CustomerBillingPage;